/**
 * Descripes a sort rule. Is used to generate a breeze data set.
 */
var SortDescriptor = /** @class */ (function () {
    function SortDescriptor(name, property, direction, order) {
        this.name = name;
        this.property = property;
        this.direction = direction;
        this.order = order;
    }
    return SortDescriptor;
}());
export { SortDescriptor };
